export default __webpack_public_path__ + "static/media/ChefTuring - 3338.6bc3b791.jpeg";